<template>
  <span>
    <h3 id="titulo" class="text-center">Relatório de Prestações Descontadas</h3>
    <div>
      <table id="tabela">
        <thead>
          <tr>
            <th>Mês/Ano</th>
            <th>Matricula</th>
            <th>CPF</th>
            <th>Nome</th>
            <th>Entidade</th>
            <th>Rubrica</th>
            <th>Consignatária</th>
            <th>Contrato</th>
            <th>Tipo</th>
            <th>Parcela</th>
            <th class="text-right">Valor Parcela</th>
            <th class="text-right">Valor Prestação</th>
            <th class="text-right">Valor Descontado</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(prestacao, index) in prestacoesDescontadas" :key="index">
            <td>{{ prestacao.mesReferencia }}/{{ prestacao.anoReferencia }}</td>
            <td>{{ prestacao.matricula }}</td>
            <td>{{ prestacao.cpfServidor }}</td>
            <td>{{ truncateText(prestacao.nomeServidor, 30) }}</td>
            <td>{{ truncateText(prestacao.nomeEntidade, 12) }}</td>
            <td>{{ prestacao.rubrica }}</td>
            <td>{{ truncateText(prestacao.nomeConsignataria, 20) }}</td>
            <td>{{ truncateText(prestacao.numeroContrato, 12) }}</td>
            <td>{{ prestacao.tipo }}</td>
            <td>{{ prestacao.parcelaPrazo }}</td>
            <td class="formatarValorMoeda">
              <span v-if="relatorioStore.contentType == 'PDF'">
                {{ formatarValorMoeda(prestacao.valorParcela) }}
              </span>
              <span v-else>
                {{ formatarValorSemCifrao(prestacao.valorParcela) }}
              </span>
            </td>
            <td class="formatarValorMoeda">
              <span v-if="relatorioStore.contentType == 'PDF'">
                {{ formatarValorMoeda(prestacao.valorPrestacao) }}
              </span>
              <span v-else>
                {{ formatarValorSemCifrao(prestacao.valorPrestacao) }}
              </span>
            </td>
            <td class="formatarValorMoeda">
              <span v-if="relatorioStore.contentType == 'PDF'">
                {{ formatarValorMoeda(prestacao.valorDescontado) }}
              </span>
              <span v-else>
                {{ formatarValorSemCifrao(prestacao.valorDescontado) }}
              </span>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="10"><strong>Total:</strong></td>
            <td class="formatarValorMoeda">
              <span v-if="relatorioStore.contentType == 'PDF'">
                {{ formatarValorMoeda(calcularTotal('valorParcela')) }}
              </span>
              <span v-else>
                {{ formatarValorSemCifrao(calcularTotal('valorParcela')) }}
              </span>
            </td>
            <td class="formatarValorMoeda">
              <span v-if="relatorioStore.contentType == 'PDF'">
                {{ formatarValorMoeda(calcularTotal('valorPrestacao')) }}
              </span>
              <span v-else>
                {{ formatarValorSemCifrao(calcularTotal('valorPrestacao')) }}
              </span>
            </td>
            <td class="formatarValorMoeda">
              <span v-if="relatorioStore.contentType == 'PDF'">
                {{ formatarValorMoeda(calcularTotal('valorDescontado')) }}
              </span>
              <span v-else>
                {{ formatarValorSemCifrao(calcularTotal('valorDescontado')) }}
              </span>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </span>
</template>

<script>
import { storeRelatorio } from '@/stores/relatorio'

export default {
  setup() {
    const relatorioStore = storeRelatorio()
    return { relatorioStore }
  },

  data() {
    return {
      prestacoesDescontadas: [],
    }
  },

  created() {
    this.prestacoesDescontadas = this.relatorioStore.response
  },

  mounted() {
    if ('EXCEL' === this.relatorioStore.contentType) {
      this.$emit('gerarExcel')
    } else {
      this.$emit('gerarPDF')
    }
  },

  methods: {
    formatarValorMoeda(value) {
      if (value == null || typeof value === 'undefined' || value == '') {
        return '-'
      } else {
        return value.toLocaleString('pt-BR', {
          style: 'currency',
          currency: 'BRL',
        })
      }
    },
    formatarValorSemCifrao(value) {
      if (value == null || typeof value === 'undefined' || value == '') {
        return '-'
      } else {
        const currencyFractionDigits = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'DOL',
        }).resolvedOptions().maximumFractionDigits

        return value.toLocaleString('en-US', {
          maximumFractionDigits: currencyFractionDigits,
        })
      }
    },
    calcularTotal(campo) {
      return this.prestacoesDescontadas.reduce(
        (sum, item) => sum + (item[campo] || 0),
        0,
      )
    },
    truncateText(text, length) {
      if (!text) return text
      if (text.length > length) {
        return text.substring(0, length) + '...'
      } else {
        return text
      }
    },
  },
}
</script>
prestacao.nomeServidor
<style lang="scss" scoped>
#titulo {
  font-weight: bold;
}

.formatarValor {
  text-align: right !important;
}

#tabela {
  border-collapse: collapse;
  border-spacing: 0;
  width: 100%;
  font-size: 11px;
}
#tabela th {
  background-color: #333;
  color: #fff;
  padding: 5px;
  padding-top: 10px;
  padding-bottom: 10px;
  text-align: center;
}

#tabela td {
  text-align: center;
  padding-left: 5px;
  padding-right: 5px;
  overflow: hidden;
  text-overflow: ellipsis;
  border: 1px solid #ccc;
}

#tabela tfoot {
  background-color: #333;
  color: #fff;
  text-align: center;
  border: 1px solid #333;
}

#subTotal {
  background-color: #f2f2f2;
}

@media print {
  @page {
    margin: 10mm;
    size: landscape; /* Opcional: imprimir em modo paisagem para caber mais colunas */
  }
  #titulo {
    font-weight: bold;
  }

  .formatarValor {
    text-align: right !important;
  }

  #tabela {
    border: 1px solid black;
    border-collapse: collapse;
    width: 100%;
    font-size: 11px;
  }
  #tabela th {
    background-color: #333;
    color: #fff;
    padding: 5px;
    padding-top: 10px;
    padding-bottom: 10px;
    text-align: left;
  }

  #tabela td {
    padding: 8px;
    padding-top: 10px;
    padding-bottom: 10px;
  }

  #tabela tbody tr:nth-child(even) {
    background-color: #f2f2f2;
  }

  #tabela tfoot {
    background-color: #666666;
    color: #fff;
  }
}
</style>
